// extracted by mini-css-extract-plugin
export default {"wrapper":"PlusMinus_wrapper__cJ9Vo","circle":"PlusMinus_circle__rXgZt"};